import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMildIrritationEmojiSecondary from './svgs/MildIrritationEmojiSecondary.js';
import SvgMildIrritationEmoji from './svgs/MildIrritationEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var mildIrritationEmoji = (props => useIcon(SvgMildIrritationEmoji, SvgMildIrritationEmojiSecondary, props));

export { mildIrritationEmoji as default };
